import React from 'react'

function PaymentSuccessfull() {
  return ( 
    <div>
      Payment successfull
    </div>
  )
}

export default PaymentSuccessfull
